import { log2 } from "./log2";

const log = log2("authGuard");

let _sessionInvalid = false;
let _logoutDispatched = false;

/**
 * 401 veya açık oturum iptali sonrası çağrılır.
 * Tüm sonraki API isteklerini request interceptor'da bloklar.
 * @param {string} [source] - Örn: axios.response.401, auth.logout
 * @param {Object} [meta] - url, context vb.
 */
export const markSessionInvalid = (source, meta) => {
    if (_sessionInvalid) return;
    _sessionInvalid = true;
    const payload = Object.assign({}, meta && typeof meta === "object" ? meta : {}, {
        source: source || "unknown",
    });
    log.warn("[session-invalid] guard işaretlendi", payload);
};

/**
 * Login başarılı olduğunda guard sıfırlanır, istekler tekrar akmaya başlar.
 */
export const resetSessionGuard = () => {
    _sessionInvalid = false;
    _logoutDispatched = false;
    log.debug("[session-invalid] guard sıfırlandı");
};

export const isSessionInvalid = () => _sessionInvalid;

/**
 * 401 interceptor'dan tek seferde logout dispatch etmek için kullanılır.
 * İlk çağrıda true döner, sonraki çağrılarda false döner.
 * @param {string} [source]
 * @param {Object} [meta]
 */
export const shouldDispatchLogout = (source, meta) => {
    if (_logoutDispatched) {
        log.debug("[session-invalid] logout zaten kuyruklandı, tekrar dispatch yok", {
            source: source || "unknown",
            meta: meta || {},
        });
        return false;
    }
    _logoutDispatched = true;
    log.warn("[session-invalid] auth/logout dispatch edilecek (tek sefer)", {
        source: source || "unknown",
        meta: meta || {},
    });
    return true;
};
